// extracted by mini-css-extract-plugin
export var about = "about-module--about--H9dbg";
export var description = "about-module--description--RsoM6";
export var image = "about-module--image--tm64C";
export var text = "about-module--text--ONoaS";
export var toggleWrapper = "about-module--toggleWrapper--59Bdn";